/* eslint-disable import/prefer-default-export */
export const ORDERING_DOCUMENTLIST_TYPE = 'ordering';
export const AVAILABLE_FACTORING_DOCUMENTLIST_TYPE = 'available-factoring';
